import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { nlpIntegration } from '@mi-front/api-clients';
import { minsToMs } from '@mi-front/core';
import { DateTime } from 'luxon';
import { useCallback } from 'react';
import { useGoToTime } from '../../../../hooks/cursor/useGoToTime';

/**
 * Hook to load an associated topic by id and go to its start time.
 * Uses useGoToTime with 2 min context before the topic so the user sees context before the topic start.
 */
export function useGoToAssociatedTopicTime(associatedTopicId: string | null, onClose?: () => void) {
  const { slug } = useActiveStation();
  const { goToTime } = useGoToTime({
    focusOffsetMs: minsToMs(2),
  });

  const { data: topic, isLoading } = nlpIntegration.useGetLiveTopicsTopicById(
    slug ?? '',
    associatedTopicId ?? '',
    {
      query: { enabled: !!slug && !!associatedTopicId },
    },
  );

  const goToTopicTime = useCallback(() => {
    if (!topic?.start_time) {
      return;
    }

    goToTime(DateTime.fromISO(topic.start_time).toMillis());
    onClose?.();
  }, [topic?.start_time, goToTime, onClose]);

  return { isLoading, topic, goToTopicTime };
}
